const hasClass = (node, name) => String(node?.config?.classStyle || '').split(/\s+/).includes(name)
const children = node => [...(node?.config?.children || []), ...(node?.config?.items || [])]
const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key)
const bannerLink = link => typeof link === 'string' ? { type: 'link', value: link } : link

export const AUSTRALIA_HERO_BANNER_CSS = `/* AU homepage banner: 30:17, complete image */
.au-figma-hero.au-figma-hero{height:auto!important;min-height:0!important;max-height:none!important;aspect-ratio:30 / 17;overflow:hidden}
.au-figma-hero.au-figma-hero>.row-wrap,.au-figma-hero.au-figma-hero>.row-wrap>.col-wrap,.au-figma-hero.au-figma-hero .au-figma-hero-image{height:100%!important;min-height:0!important;max-height:none!important}
.au-figma-hero.au-figma-hero img{width:100%!important;max-width:100%!important;height:100%!important;position:static!important;left:auto!important;top:auto!important;object-fit:contain!important;object-position:center!important}`

function clearFixedHeight(config, isBanner) {
  config.heightMode = isBanner ? 'fill' : 'auto'
  for (const key of ['height', 'minHeight', 'maxHeight']) delete config[key]
  if (isBanner) {
    config.aspectRatio = 17 / 30
    config.imageFit = 'contain'
  }
  if (config.styles) {
    config.styles = config.styles.split(';').filter(rule => !/^\s*(height|min-height|max-height|aspect-ratio)\s*:/i.test(rule)).join(';')
  }
}

// Apply the AU homepage contract before rendering and when loading the editor.
// Keep slides, links and unrelated page content; replace the legacy crop/height
// rules in every breakpoint, including documents already saved as banners.
export function upgradeAustraliaHeroBanners(pages) {
  if (!Array.isArray(pages)) return pages
  function hasHero(nodes) {
    return nodes.some(node => hasClass(node, 'au-figma-hero') || hasClass(node, 'au-figma-hero-image') || hasHero(children(node)))
  }
  if (!pages.some(page => hasHero(page.elements || []))) return pages
  const result = JSON.parse(JSON.stringify(pages))
  function visit(nodes, inHero = false) {
    return nodes.filter(node => !(inHero && hasClass(node, 'au-figma-hero-indicator'))).map(node => {
      const config = node.config || {}
      const isBanner = ['imageItem', 'banner'].includes(node.type) && hasClass(node, 'au-figma-hero-image')
      const isFrame = hasClass(node, 'au-figma-hero')
      if (isBanner) {
        const first = { url: config.src || '', alt: config.alt || '', useLazy: config.disabledLazyLoad !== true }
        if (config.link) first.link = bannerLink(config.link)
        node.type = 'banner'
        config.imageConfigs = Array.isArray(config.imageConfigs) ? config.imageConfigs : (first.url ? [first] : [])
        config.isAuto = config.isAuto ?? true
        config.timer = config.timer ?? 5
        for (const point of ['wide', 'desktop', 'tablet', 'mobile']) {
          const patch = config.responsive?.[point]
          if (!patch) continue
          const values = { ...patch, ...patch.overrides }
          if (!values.imageConfigs && (hasOwn(values, 'src') || hasOwn(values, 'link'))) {
            const image = { ...first }
            if (hasOwn(values, 'src')) image.url = values.src
            if (hasOwn(values, 'link')) image.link = bannerLink(values.link)
            patch.overrides = { ...patch.overrides, imageConfigs: image.url ? [image] : [] }
          }
        }
      }
      if (isBanner || isFrame) {
        clearFixedHeight(config, isBanner)
        for (const point of ['wide', 'desktop', 'tablet', 'mobile']) {
          const patch = config.responsive?.[point]
          if (!patch) continue
          clearFixedHeight(patch, isBanner)
          if (patch.overrides) clearFixedHeight(patch.overrides, isBanner)
        }
      }
      const inside = inHero || hasClass(node, 'au-figma-hero')
      for (const field of ['children', 'items']) if (Array.isArray(config[field])) config[field] = visit(config[field], inside)
      return node
    })
  }
  result.forEach(page => {
    if (!hasHero(page.elements || [])) return
    page.elements = visit(page.elements || [])
    if (!(page.info?.cssText || '').includes(AUSTRALIA_HERO_BANNER_CSS)) {
      page.info = { ...page.info, cssText: `${page.info?.cssText || ''}\n${AUSTRALIA_HERO_BANNER_CSS}\n` }
    }
  })
  return JSON.stringify(result) === JSON.stringify(pages) ? pages : result
}
